import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faBars } from '@fortawesome/free-solid-svg-icons';

const MAX_MOBILE_WIDTH = 600;

export default function WebsiteNavbar() {
    const [openNavbarSubmenu, setOpenNavbarSubmenu] = useState(null);
    const [openMobileMenu, setOpenMobileMenu] = useState(false);

    const useWindowResizeThreshold = threshold => {
        const [isMobileSize, setIsMobileSize] = useState(window.innerWidth <= threshold)
        const prevWidth = useRef(window.innerWidth)

        useEffect(() => {
            const handleResize = () => {
                const currWidth = window.innerWidth
                if (currWidth <= threshold && prevWidth.current > threshold){
                    setIsMobileSize(true);
                } else if (currWidth > threshold && prevWidth.current <= threshold) {
                    setIsMobileSize(false);
                }
                prevWidth.current = currWidth;
            }

            window.addEventListener("resize", handleResize)
            return () => window.removeEventListener("resize", handleResize)
        }, []);

        return isMobileSize
    }

    const isMobileSize = useWindowResizeThreshold(MAX_MOBILE_WIDTH);

    return (
        <>
        <div id='homepage-navbar' className='dark-blue' onMouseLeave={()=>setOpenNavbarSubmenu(null)}>
            <Link id="homepage-logo-container" className="text-align-center" to='/'>
                <img className='homepage-logo-img' src={require("../../../../images/logo-white.png")} alt='Edario Logo' />
                <div className='main-sidebar-logo-text white-text'>edario</div>
            </Link>
             {isMobileSize ? (
                <div id='navbar-mobile'>
                    <FontAwesomeIcon icon={faBars} onClick={()=>setOpenMobileMenu(!openMobileMenu)}></FontAwesomeIcon>
                </div>
             ): (
                <div id='navbar-full'>
                    <div id='homepage-navbar-link-container' className='text-align-center'>
                        <div className='homepage-navbar-link homepage-navbar-link-with-icon' onMouseEnter={()=>setOpenNavbarSubmenu('solutions')}>
                            <div>Solutions</div>
                            <FontAwesomeIcon icon={faChevronDown} />
                            {(openNavbarSubmenu === 'solutions') &&
                                <div className='homepage-navbar-submenu'>
                                    <div className='homepage-navbar-submenu-header'>SCHEDULING</div>
                                    <Link className='homepage-navbar-submenulink' to='/solutions/highschools'>High Schools</Link>
                                    <Link className='homepage-navbar-submenulink' to='/solutions/middleschools'>Middle Schools</Link>
                                    <Link className='homepage-navbar-submenulink' to='/solutions/elementaryschools'>Elementary Schools</Link>
                                </div>
                            }
                        </div>
                        <Link className='homepage-navbar-link' to='/library'>Schedule Library</Link>
                        <Link className='homepage-navbar-link' to='/team'>Our Team</Link>
                    </div>
                    <div id='homepage-navbar-action-link-container' className='text-align-right'>
                        <Link className='homepage-navbar-link white-text' to='/app'>Log in</Link>
                        <Link className='homepage-navbar-btn' to='/contact'>Book a Demo</Link>
                    </div>
                </div>
            )}
        </div>
        {(isMobileSize && openMobileMenu) &&
            <div id='homepage-navbar-mobile-link-container'>
                <div className='homepage-navbar-mobile-link' onClick={()=>setOpenNavbarSubmenu('solutions')}>Solutions</div>
                {(openNavbarSubmenu === 'solutions') &&
                    <div className='homepage-navbar-mobile-submenu'>
                        <div className='homepage-navbar-mobile-submenu-header'>SCHEDULING</div>
                        <Link className='homepage-navbar-mobile-submenulink' to='/solutions/highschools'>High School</Link>
                        <Link className='homepage-navbar-mobile-submenulink' to='/solutions/middleschools'>Middle School</Link>
                        <Link className='homepage-navbar-mobile-submenulink' to='/solutions/elementaryschools'>Elementary School</Link>
                    </div>
                }
                <Link className='homepage-navbar-mobile-link' to='/library'>Schedule Library</Link>
                <Link className='homepage-navbar-mobile-link' to='/team'>Our Team</Link>
                <Link className='homepage-navbar-mobile-link' to='/app'>Log in</Link>
                <Link className='homepage-navbar-btn' to='/contact' style={{marginLeft:'30px'}}>Book a Demo</Link>
            </div>
        }
        </>
    );
}

